import { cloneDeep, sortBy } from "lodash";
import { ADD_FORCES_INPUT_SUCCESS, DEACTIVATE_FORCES_INPUT_SUCCESS, GET_FORCES_INPUTS_ERROR, GET_FORCES_INPUTS_STARTING, GET_FORCES_INPUTS_SUCCESS, UPDATE_FORCES_INPUT_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

const sortByOrder = (newState) => { }

export default function forcesInputReducer(state = initialState.forcesInputs, action) {
    switch (action.type) {
        case GET_FORCES_INPUTS_STARTING: {
            const newState = cloneDeep(state);
            newState.loading = true;
            newState.loaded = false;
            return newState;
        }

        case GET_FORCES_INPUTS_SUCCESS: {
            const newState = cloneDeep(state);
            const ids = [];
            action.data.forcesInputData.forEach((forcesInput) => {
                const forcesInputId = forcesInput.id;
                ids.push(forcesInputId);
                newState.map[forcesInputId] = forcesInput;
            });
            newState.ids = ids;
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case GET_FORCES_INPUTS_ERROR: {
            const newState = cloneDeep(state);
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case UPDATE_FORCES_INPUT_SUCCESS: {
            const { forcesInput } = action.data;
            const newState = cloneDeep(state);
            const forcesInputId = forcesInput.id;
            newState.map[forcesInputId] = forcesInput;

            sortByOrder(newState);

            return newState;
        }

        case ADD_FORCES_INPUT_SUCCESS: {
            const { forcesInputData } = action.data;
            const newState = cloneDeep(state);
            const forcesInputId = forcesInputData.id;
            newState.map[forcesInputId] = forcesInputData;
            newState.ids.push(forcesInputId);

            sortByOrder(newState);

            return newState;
        }

        case DEACTIVATE_FORCES_INPUT_SUCCESS: {
            const { forcesInputId } = action;
            const newState = cloneDeep(state);
            newState.ids = newState.ids.filter((mbid) => {
                return forcesInputId !== mbid;
            });

            if (newState.map[forcesInputId]) {
                newState.map[forcesInputId].isActive = 0;
            }
            sortByOrder(newState)
            return newState;
        }

        default: {
            return state;
        }
    }
}